import './Section.css';
import { FaCheck, FaRegCopy } from "react-icons/fa6";
import { Button, Tooltip } from '@mantine/core';
import { useClipboard } from '@mantine/hooks';
import { useState } from 'react';
import { FaAmazon } from "react-icons/fa";
import { GiPresent } from "react-icons/gi";

import {
  StyleSheet,
  View,
  Text,
  TouchableOpacity
} from 'react-native';
import properties from '../properties.json'
import { Gift, CreditCard, Heart, Store } from 'lucide-react-native';

export function Regalos() {
  const paymentMethods = [
    { key: 'número de tarjeta', name: 'Tarjeta de débito BBVA', handle: '4152313839142333', color: '#008CFF', icon: '💳' },
    { key: 'número de cuenta', name: 'Número de cuenta BBVA', handle: '1518189059', color: '#00457C', icon: '🏧' },
    { key: 'cuenta CLABE', name: 'Desde cualquier banco (CLABE)', handle: '012180015181890595', color: '#00457C', icon: '🏦' }
  ];

  return (
    <div id="sectionRegalos" className='sectionBody'>
      <div className="header">
        <Gift size={32} color={properties.detailsColor} className='mainIcon' />
        <h2 className='title'>Propuesta de Regalos</h2>
        <div className='line' />
        <br />
        <Text style={styles.description}>
          Tu presencia en nuestra boda es el mejor regalo de todos. Pero si deseas honrarnos
          con un obsequio extra, te compartimos las siguientes opciones.
        </Text>
      </div>
      <br />
      {/* Tarjeta de Métodos de Pago */}
      <View style={styles.card}>
        <View style={styles.cardHeader}>
          <CreditCard size={24} color={properties.detailsColor} />
          <Text style={styles.cardTitle}>Transferencia bancaria</Text>
        </View>
        <View style={styles.titleCardInfo}>
          <Text style={styles.footerText}>
            <Heart size={14} color={properties.detailsColor} /> Cualquier monto será bien recibido. Muchas gracias <Heart size={14} color={properties.detailsColor} />
          </Text>
        </View>
        <View style={styles.grid}>
          {paymentMethods.map((method) => (
            <View
              key={method.name}
              style={styles.methodBox}
            >
              <View style={styles.methodHeader}>
                <View style={[styles.iconContainer, { backgroundColor: method.color }]}>
                  <Text style={styles.methodEmoji}>{method.icon}</Text>
                </View>
                <View>
                  <Text style={styles.methodName}>{method.name}</Text>
                  <Text style={styles.tapToCopy}>{method.handle}</Text>
                </View>
              </View>
              {ButtonCopy(method.key, method.handle)}
            </View>
          ))}
        </View>

        <View style={styles.footerInfo}>
          <Text style={styles.footerText}>
            Beneficiario: Jaime Casales Medina
          </Text>
          <Text style={styles.footerText}>
            Concepto: Regalo de boda (No consideramos necesario agregar nombre de quien envía el regalo, pero si gustas puedes hacerlo)
          </Text>
        </View>
      </View>

      {/* Registro Tradicional */}
      <View style={[styles.card, styles.lastCard]}>
        <Text style={styles.cardTitleCentered}><Store size={24} color={properties.detailsColor} /> Mesas de Regalos</Text>
        <View style={styles.traditionalGrid}>
          <TouchableOpacity style={styles.storeButton}>
            <View 
            onClick={(e) => {
                e.preventDefault();
                window.open("https://www.amazon.com.mx/wedding/guest-view/3KW3WLKLFZI7S", "_blank");
              }}
              style={[styles.storeIcon, styles.storeColor0]}>
              <FaAmazon color='white' />
            </View>
            <Text style={styles.storeName}>Amazon</Text>
          </TouchableOpacity>
          <TouchableOpacity style={styles.storeButton}>
            <View
              onClick={(e) => {
                e.preventDefault();
                window.open("https://mesaderegalos.liverpool.com.mx/milistaderegalos/51971957", "_blank");
              }}
              style={[styles.storeIcon, styles.storeColor1]}>
              <GiPresent color='white' />
            </View>
            <Text style={styles.storeName}>Liverpool</Text>
          </TouchableOpacity>
        </View>
      </View>
    </div>
  );
}

function ButtonCopy(key, value) {
  const [opened, setOpened] = useState(false);
  const clipboard = useClipboard();
  function clipboardTimeout() {
    setTimeout(() => {
      setOpened(false);
    }, 1000);
    setOpened(true);
  }
  return (
    <Tooltip
      label="Copiado al portapapeles"
      offset={5}
      position="bottom"
      radius="xl"
      transitionProps={{ duration: 100, transition: 'slide-down' }}
      opened={opened}
    >
      <Button
        variant="light"
        rightSection={
          opened ? (
            <FaCheck size={20} stroke={1.5} />
          ) : (
            <FaRegCopy size={20} stroke={1.5} />
          )
        }
        radius="xl"
        size="md"
        pr={14}
        h={48}
        styles={{ section: { marginLeft: 22 } }}
        onClick={() => {
          clipboardTimeout();
          clipboard.copy(value);
        }
        }
      >
        Copiar {key}
      </Button>
    </Tooltip>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f9f6f7', // rose-50
    paddingHorizontal: 20,
    paddingVertical: 40,
  },


  underline: {
    height: 2,
    width: 80,
    backgroundColor: '#fda4af',
    marginBottom: 20,
  },
  description: {
    textAlign: 'center',
    color: '#4b5563',
    lineHeight: 22,
    fontSize: 16,
  },
  card: {
    width: '95%',
    maxWidth: '800px',
    backgroundColor: '#fff',
    borderRadius: 20,
    padding: 24,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 10 },
    shadowOpacity: 0.1,
    shadowRadius: 15,
    elevation: 0,
    marginBottom: 20,
  },
  cardHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 24,
  },
  cardTitle: {
    fontSize: 20,
    fontWeight: '600',
    marginLeft: 12,
    color: '#1f2937',
  },
  grid: {
    gap: 16,
  },
  methodBox: {
    borderWidth: 2,
    borderColor: '#e5e7eb',
    borderRadius: 12,
    padding: 16,
  },
  methodHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12,
  },
  iconContainer: {
    width: 48,
    height: 48,
    borderRadius: 10,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12,
  },
  methodEmoji: {
    fontSize: 24,
  },
  methodName: {
    fontSize: 16,
    fontWeight: '700',
    color: '#111827',
  },
  tapToCopy: {
    fontSize: 16,
    color: '#5c5f63',
  },
  handleContainer: {
    backgroundColor: '#f9fafb',
    borderRadius: 8,
    padding: 10,
  },
  handleText: {
    textAlign: 'center',
    fontFamily: 'Platform' === 'ios' ? 'Courier' : 'monospace',
    color: '#374151',
  },
  footerInfo: {
    marginTop: 10,
    paddingTop: 24,
    borderTopWidth: 1,
    borderTopColor: '#e5e7eb',
    alignItems: 'center',
  },
  titleCardInfo: {
    marginTop: 0,
    paddingTop: 0,
    borderTopColor: '#e5e7eb',
    alignItems: 'center',
    marginBottom: 20,
  },
  footerText: {
    color: '#1f2937',
    fontSize: 15,
    textAlign: 'center'
  },
  cardTitleCentered: {
    fontSize: 22,
    fontWeight: '600',
    textAlign: 'center',
    marginBottom: 24,
    color: '#1f2937'
  },
  traditionalGrid: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  storeButton: {
    alignItems: 'center',
    flex: 1,
  },
  storeIcon: {
    width: 60,
    height: 60,
    borderRadius: 30,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 8,
  },
  storeName: {
    fontSize: 12,
    fontWeight: '600',
    color: '#4b5563',
  },
  storeColor0: { backgroundColor: '#4c658d' },
  storeColor1: { backgroundColor: '#E4007C' },
  lastCard: {
    marginBottom: 60,
  }
});